import { render } from "./balance.vue?vue&type=template&id=35bb699a"
import script from "./balance.vue?vue&type=script&lang=js"
export * from "./balance.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT_REPOS\\pilot-tools\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__